import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { PageLayout } from "../components/page-layout";
import { PageLoader } from "../components/page-loader";
import { StatusCard } from "../components/onyx/StatusCard";
import { acceptOrgInvite } from "../services/backend.service";

export const AcceptOrgInvitePage = () => {
  const [searchParams] = useSearchParams();
  const { logout } = useAuth0();
  const [status, setStatus] = useState("accepting");
  const [orgName, setOrgName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setErrorMessage("Missing invitation token");
      return;
    }

    const accept = async () => {
      const { data, error } = await acceptOrgInvite(token);
      if (error) {
        setStatus("error");
        setErrorMessage(error.message || "Failed to accept invitation");
      } else {
        setOrgName(data?.org_name || "the organization");
        setStatus("success");
        setTimeout(() => {
          logout({ logoutParams: { returnTo: window.location.origin } });
        }, 3000);
      }
    };

    accept();
  }, [token, logout]);

  if (status === "accepting") {
    return (
      <PageLayout>
        <div className="content-layout">
          <StatusCard tone="muted">
            <PageLoader />
            <p>Joining organization...</p>
          </StatusCard>
        </div>
      </PageLayout>
    );
  }

  if (status === "error") {
    return (
      <PageLayout>
        <div className="content-layout">
          <StatusCard title="Unable to Join" tone="error">
            <p>{errorMessage}</p>
            <p className="onyx-status-card__hint">
              The invitation may have expired or already been used. Please contact the person who invited you.
            </p>
          </StatusCard>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div className="content-layout">
        <StatusCard title={`You've joined ${orgName}`} tone="success">
          <p>You have been successfully added to the organization.</p>
          <p className="onyx-status-card__hint">
            You will be redirected to log in and select your organization in a moment...
          </p>
        </StatusCard>
      </div>
    </PageLayout>
  );
};
